const projects = [
  {
    title: {
      en: 'Eat the Strip',
      fr: 'Eat the Strip',
    },
    tech: ['Next JS', 'Netlify CMS', 'React', 'Javascript'],
    description: {
      en:
        'A food review blog that focuses on strip mall gems in the national capital region.',
      fr:
        'Un blog de critiques culinaires mettant en valeur les trésors cachés des centres commerciaux de la région de la capitale nationale.',
    },
    image: 'images/eatthestrip.png',
    live: 'https://eatthestrip.com/',
    id: 1,
  },
]

export default projects
